module.exports = __webpack_public_path__ + "static/media/lib-1.fd69cc39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/img/library/lib-1.jpg
// module id = 718
// module chunks = 0